import { render, staticRenderFns } from "./NewSupportTicket.vue?vue&type=template&id=07975580&"
import script from "./NewSupportTicket.vue?vue&type=script&lang=js&"
export * from "./NewSupportTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports